// Footer year (spec D9): the HTML carries the build year, the visitor's clock gives the
// current one.

export function initFooterYear() {
  const year = document.getElementById("footer-year");
  if (year) year.textContent = String(new Date().getFullYear());
}
